import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import utils from '../../../utils/utils.functions';
 
class ComponentToPrint extends React.Component {

 constructor() {
   super();
   this.totalPuntoVenta = 0;
   this.totalTransferencia = 0;
   this.totalEfectivo = 0;
 }
  
  componentDidUpdate() {
    this.totalPuntoVenta = 0;
    this.totalTransferencia = 0;
    this.totalEfectivo = 0;
  }

  calculateTotalAmount = () => {
    const { data } = this.props;
    let totalAmount = 0;
    data.guiasRespuesta.forEach((element) => {
      if (element.anulado === 0) {
        totalAmount += element.monto_pago;
      }
    })
    return utils.formatMoney(totalAmount);
  }

  calculateFormaPagos = (e) => {
    if (e.tipo_pago.description === 'Punto de venta') {
      this.totalPuntoVenta += parseInt(e.monto_pago);
    } else if (e.tipo_pago.description === 'Transferencia') {
      this.totalTransferencia += parseInt(e.monto_pago);
    } else if (e.tipo_pago.description === 'Efectivo') {
      this.totalEfectivo += parseInt(e.monto_pago);
    }
  }

  nameSucursal = () => {
    const names = this.props.data.sucursalesNames.map(e => e.description);
    return names.join();
  }

  render() {
    const { data, prefijo } = this.props;
    return (
      <div style={{ padding: 10 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10
        }}
      >
        <div>
          <div style={{ textAlign: "left" }}>
            <h3>Reporte ventas por día</h3>
          </div>
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Rango de días</small>
            <div>Desde {moment(data.fecha.start).format('DD/MM/YYYY')} hasta {moment(data.fecha.end).format('DD/MM/YYYY')}</div>
          </div>
        </div>
        <div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Generado el</small>
            <div>{moment().format('DD/MM/YYYY H:m:s')}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Sucursal</small>
            <div>{this.nameSucursal()}</div>
          </div>
        </div>
      </div>

      <div style={{ width: '100%', display: 'flex', backgroundColor: '#dfddddcc', paddingLeft: 10, paddingRight: 10 }}>
        <div style={{ width: '10%'}}>
          <b>Guia</b>
        </div>
        <div style={{ width: '20%', textAlign: 'left'}}>
          <b>Cliente</b>
        </div>
        <div style={{ width: '10%', textAlign: 'right'}}>
          <b>Tipo</b>
        </div>
        <div style={{ width: '20%', textAlign: 'right'}}>
          <b>Forma de pago</b>
        </div>
        <div style={{ width: '20%', textAlign: 'right'}}>
          <b>Referencia</b>
        </div>
        <div style={{ width: '20%', textAlign: 'right'}}>
          <b>Monto</b>
        </div>
      </div>
  
      {data.guiasRespuesta.map((guia) => {
        return <div key={guia.id} style={{ width: '100%', display: 'flex', backgroundColor: guia.anulado ? '#dfddddcc' : 'white', paddingLeft: 10, paddingRight: 10, borderBottom: '1px solid #ccc' }}>
        <div style={{ width: '10%'}}>
          {prefijo}-{guia.guia_paquete}
        </div>
        <div style={{ width: '20%', textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
          {guia.cliente.rut} <br></br>
          {guia.cliente.name}
        </div>
        <div style={{ width: '10%', textAlign: 'right'}}>
          {guia.master_guia.rel_tipos.description}
        </div>
        <div style={{ width: '20%', textAlign: 'right'}}>
          {guia.pagos_guia.map((e, i) => {
            if (!guia.anulado) {
              this.calculateFormaPagos(e);
            }
            return <div key={i} >
                     {e.tipo_pago.description}
                   </div>
          })}
        </div>
        <div style={{ width: '20%', textAlign: 'right'}}>
          {guia.pagos_guia.map((e, i) => {
            return <div key={i} >
                     {!e.referencia ? '-' : e.referencia}
                   </div>
          })}
        </div>
        <div style={{ width: '20%', textAlign: 'right'}}>
          {guia.pagos_guia.map((e, i) => {
            return <div key={i} style={{ color: guia.anulado ? 'red' : 'black' }}>
                      {guia.anulado ? '-' : '+'} {utils.formatMoney(e.monto_pago)}
                   </div>
          })}
        </div>
      </div>
      })} 
      
      <div style={{ width: "100%", display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 10, border: "1px solid #ccc", padding: '0px 10px 0px 10px' }}>
       <div>
         <b>Efectivo: {utils.formatMoney(this.totalEfectivo)}</b>
       </div>
       <div>
         <b>Punto de venta: {utils.formatMoney(this.totalPuntoVenta)}</b>
       </div>
       <div>
         <b>Transferencia: {utils.formatMoney(this.totalTransferencia)}</b>
       </div>
       <div>
         <b>Total de ventas: {this.calculateTotalAmount()}</b>
       </div>
      </div>
    </div>
    );
  }
}


const PrinterDiario = ({ data, suc, config }) => {

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
 
  return (
    <div>
      <div style={{ display: 'none'}}>
       <ComponentToPrint 
        data={data}
        suc={suc}
        prefijo={config.prefijo_correlativo_guia}
        ref={componentRef}
      />
      </div>
      <button onClick={handlePrint} type="button" className="btnx btnx-warn p-10" style={{ padding: 10 }}>Imprimir reporte</button>
    </div>
  );
};

export default PrinterDiario;